import request from '@/utils/request'
import {cmsServerContext} from '@/config/config'

/**
 * 查询客户能源类型
 * @param customerId
 */
export function getCustomerEnergy(customerId) {
  return request({
    url: cmsServerContext + '/customerEnergy/list/' + customerId,
    method: 'get'
  })
}

export function getCustomerEenrgies(customerId) {
  return request({
    url: cmsServerContext + '/customerEnergy/getCustomerEnergies' +
      '/' + customerId,
    method: 'get'
  })
}

/**
 * 客户能源分项树
 * @param customerId
 */
export function tree(customerId) {
  return request({
    url: cmsServerContext + '/customerEnergy/tree/' + customerId,
    method: 'get'
  })

}

/**
 * 删除客户能源分项
 * @param id
 */
export function deleteCustomerEnergy(id, customerId) {
  return request({
    url: cmsServerContext + '/customerEnergy/deleteCustomerEnergy/' + id + '/' + customerId,
    method: 'delete'
  })
}

/**
 * 修改客户能源分项
 * @param customerEnergy
 */
export function updateCustomerEnergy(customerEnergy) {
  return request({
    url: cmsServerContext + '/customerEnergy/updateCustomerEnergy',
    method: 'post',
    data: customerEnergy
  })
}

